import type { ReactNode } from "react";
import { AppFooter } from "./AppFooter";
import { AppHeader } from "./AppHeader";

export function AppShell({ children, right, extra }: { children: ReactNode; right?: ReactNode; extra?: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <AppHeader right={right} extra={extra} />
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6">{children}</main>
      <AppFooter />
    </div>
  );
}
